const tags = state => state.tags

export default {
  tags
}
